import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Alliance, WarInfo } from "../../../../lib/types";
import { toggleWarApplication } from "../../../../store/actions";
import AllianceInfoLink from "../../../Common/AllianceInfoLink";

interface IProps {
  owner: boolean;
  war?: WarInfo | null;
  alliance: Alliance;
  opponent?: Alliance | null;
}

const mapDispatchToState = (dispatch: any) => ({
  toggleWarApplicationDispatch: (apply: boolean) => dispatch(toggleWarApplication(apply))
})

const connector = connect(null, mapDispatchToState);

const WarStatus = ({
  owner,
  war,
  alliance,
  opponent,
  toggleWarApplicationDispatch
}: IProps & ConnectedProps<typeof connector>) => (
  <div className="row" style={{ display: "flex", alignItems: "center" }}>
    {war && opponent
      ? <div className="col-md-12 scrollable">
        <p className="text-center text-info-bigger">Your alliance is at war!</p>
        <table className="table">
          <thead style={{ whiteSpace: "nowrap" }}>
          <tr>
            <th className="text-left">Opponent</th>
            <th className="text-left">Our war points</th>
            <th className="text-left">Opponent's war points</th>
            <th className="text-left">Count progress</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td className="text-left"><AllianceInfoLink name={opponent.name} allianceId={opponent.id} /></td>
            <td className="text-left">{alliance.warPoints}</td>
            <td className="text-left">{opponent && opponent.warPoints}</td>
            <td className="text-left">{war.duration}/5</td>
          </tr>
          </tbody>
        </table>
      </div>
      : owner
        ? alliance.warApplication
          ? <>
            <div className="col-md-6">
              <span className="text-bigger">
                You have applied for war.
                During the count matching system will do its best to find you an opponent.
              </span>
            </div>
            <div className="col-md-4">
              <a
                href="#"
                onClick={() => toggleWarApplicationDispatch(false)}
                className="btn btn-blank btn-no-width btn-no-height"
              >
                Cancel application
              </a>
            </div>
          </>
          : <>
            <div className="col-md-6">
              <span className="text-bigger">Are you ready for the war? Let's find the opponent.</span>
            </div>
            <div className="col-md-4">
              <a
                href="#"
                onClick={() => toggleWarApplicationDispatch(true)}
                className="btn btn-blank btn-no-width btn-no-height"
              >
                Find!
              </a>
            </div>
          </>
        : <div className="col-md-12">
          <span className="text-bigger">
            Alliance is not at war.
          </span>
        </div>
    }
  </div>
)

export default connector(WarStatus);
